import { render } from "./QueueSyncStatus.vue?vue&type=template&id=6ba35f20&scoped=true"
import script from "./QueueSyncStatus.vue?vue&type=script&lang=js"
export * from "./QueueSyncStatus.vue?vue&type=script&lang=js"

import "./QueueSyncStatus.vue?vue&type=style&index=0&id=6ba35f20&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba35f20"]])

export default __exports__